/**
 * Consulta dados do operador no backend proxy.
 * O backend faz a comunicação com o serviço externo seguro.
 *
 * POST /api/operator  { cpf }  → { id, name, status, ... }
 */
export async function fetchOperatorData(cpf: string, token: string): Promise<any> {
  if (!cpf || typeof cpf !== 'string') {
    throw new Error("CPF inválido fornecido para consulta de operador.");
  }
  if (!token || typeof token !== 'string') {
    throw new Error("Token de autenticação inválido fornecido para consulta de operador.");
  }

  try {
    const res = await fetch('/api/operator', {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ cpf: cpf }),
    });

    let data: any = {};
    // Tentar parsear o JSON. Se falhar, `data` permanece um objeto vazio.
    try {
      data = await res.json();
    } catch (parseError) {
      console.error("[fetchOperatorData] Erro ao parsear JSON da resposta:", parseError);
      // Se a resposta não foi OK, o erro será tratado abaixo com base no status.
      // Se a resposta foi OK mas o JSON é inválido, lançamos um erro específico.
      if (res.ok) {
        throw new Error("Resposta inválida do servidor: esperado JSON, mas recebeu outro formato ao consultar operador.");
      }
      // Se não foi OK, o erro será pego no `if (!res.ok)` abaixo.
    }

    if (!res.ok) {
      // Se a resposta não foi bem-sucedida (status 4xx, 5xx)
      const detail = data?.detail || data?.message || res.statusText || 'Erro desconhecido';
      const statusCode = res.status;
      throw new Error(`Falha na consulta do operador: ${detail} (Código: ${statusCode}).`);
    }

    // Opcional: Adicionar uma verificação básica se os dados retornados são válidos.
    // Isso depende do que você espera que `data` contenha minimamente.
    if (!data || typeof data !== 'object' || Object.keys(data).length === 0) {
      throw new Error("Dados do operador não foram retornados ou estão vazios.");
    }
    // Exemplo de verificação de propriedades mínimas esperadas:
    // if (!data.id || !data.name || !data.status) {
    //     throw new Error("Formato de dados do operador retornado inválido.");
    // }

    return data; // Retorna os dados do operador
  } catch (err: any) {
    console.error("[fetchOperatorData] Erro durante a consulta do operador:", err);
    // Relança o erro para que o componente chamador possa lidar com ele (ex: exibir um toast).
    throw err;
  }
}